export const SHERIFF_ORDER_REASON_CODES = [
    "other", "unlawful", "defamatory", "threat", "spam", "scam", "malware", "copyright", "impersonating", "privacy"
];
